module.exports = __webpack_public_path__ + "img/office.7e8b458e.svg";